import { styled } from '@mui/material';
import Stack, { type StackProps } from '@mui/material/Stack';

export const ButtonsWrapper = styled(Stack)<StackProps>(({ theme }) => ({
  gap: theme.spacing(1),
  flexDirection: 'row',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
}));
